module.exports = __webpack_public_path__ + "bs.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bs.svg
// module id = 466
// module chunks = 0